<template>
    <div class="overflow-x-auto">
        <table class="table table-xs md:table-sm xl:table-md">
            <thead>
                <tr>
                    <th>#</th>
                    <th> {{ __('Title') }} </th>
                    <th> {{ __('sales price') }} </th>
                    <th> {{ __('Count') }} </th>
                    <th> {{ __('Discount') }} </th>
                    <th> {{ __('Total') }} </th>
                    <!-- <th> {{ __('Action') }} </th> -->
                </tr>

            </thead>
            <tbody>
                <tr v-for="(item, index) in products">
                    <td> {{ index + 1 }} </td>
                    <td> {{ item.title }} </td>
                    <td> {{ item.sale_price.currency(currency) }} </td>
                    <td> {{ item.quantity + ' ' + __('Number') }} </td>
                    <td> {{ calcDiscount(item).currency(currency) }} </td>
                    <td> {{ ((item.sale_price - calcDiscount(item)) * item.quantity).currency(currency)
                    }} </td>
                    <td>
                        <router-link :to="{ name: 'user.product.show', params: { id: item.product_id } }" target="_blank"
                            :class="{ 'btn-disabled': !can('setting.view') && !can('setting.view', item.self) }"
                            class="btn btn-outline btn-primary btn-sm">
                            {{ __('Show') }}
                        </router-link>
                    </td>
                </tr>
            </tbody>
            <tfoot class="text-center" v-if="!products.length">
                <tr>
                    <td colspan="6">{{ __('No product selected.') }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script setup>
defineProps(["products", "currency"]);
const calcDiscount = (item) => {
    let amount = item.discount;
    if (item.discount && item.discount_type == 'percent') amount = item.discount * item.sale_price / 100;
    return amount;
}
</script>